<template>
    <div class="page-box">
        <div class="banner" id="banner-c">
            <p>虚仿课程</p>
            <div>
                <span class="front">教育融合科技</span>
                <span class="after">虚仿课堂让理论与实践无缝对接</span>
            </div>
        </div>
        <div class="menu-box">
            <div class="top-box">
                <div>海量虚仿课程 · 作品赏析</div>
                <div>结合行业特点，打造虚拟仿真全新亮点</div>
            </div>
            <div class="bottom-box">
                <div class="category-box" v-if="!showSlider">
                    <div v-for="(item,index) in catrgoryList" :key="index">
                        <p :class="{active:currentCategory==item.value}" @click="changeCategory(item)">{{item.label}}</p>
                        <div class="blue-line" :class="{'active-block':currentCategory==item.value}"></div>
                    </div>
                </div>
                <el-select v-else style="margin-bottom: 2rem;" @change="search" v-model="currentCategory" placeholder="请选择所属分类">
                    <el-option
                    v-for="item in catrgoryList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-input v-model="pages.keywords" @keydown.enter.native="search" clearable @clear="search" placeholder="搜索虚仿课程">
                    <i
                        class="iconfont icon-Magnifier el-input__icon"
                        :class="{'icon-active':pages.keywords}"
                        style="font-size: 16px;"
                        slot="suffix"
                        @click="search">
                    </i>
                </el-input>
            </div>
        </div>
        <div class="heart-course-box">
            <div class="heart-box" v-if="heartCourseList.length>0">
                <show-card :dataList="heartCourseList" @view_course="viewCourse"></show-card>
            </div>
            <no-data v-else></no-data>
            <img class="add-img" v-if="$permission('myselfCourse::createCourse')"  @click="$router.push('/course/createCourse')" src="../../assets/image/course/add.png" alt="">
            <div v-if="pages.total>0" class="t-page-box">
                <el-pagination
                :page-size="pages.size"
                :current-page="pages.current"
                background
                :page-sizes="[6, 12, 18, 24]"
                :pager-count="5"
                :layout="$store.state.media.layout"
                @current-change="changeCurrent"
                :total="pages.total">
                </el-pagination>
            </div>
        </div>
       <contact-info></contact-info>
    </div>
</template>

<script>
import ShowCard from './ShowCard.vue';
import { VirtualCoursePageList } from '@/api/virtualClass';
import { Category } from '@/utils/utils';
import { CoursePages } from '@/utils/page';
import ContactInfo from './ContactInfo.vue';
    export default {
     components: { ShowCard, ContactInfo },
        data(){
            return {
                /**热门课程 */
                heartCourseList:[],
                pages:{
                    keywords:'',
                    current:1,
                    size:8,
                    total:0
                },
                currentCategory:'',
                /**最新课程 */
                newCourseList:[],
                catrgoryList:[
                    {
                        label:'全部',
                        value:''
                    },
                    ...Category
                ]
            }
        },
        computed:{
            tenantId(){
                return this.$store.state.user.tenantId;
            },
            /**是否展示移动版本 */
            showSlider(){
                return this.$store.state.media.showSlider;
            }
        },
        methods:{
            /**点击查看课程 */
            viewCourse(data){
                this.$store.commit('course/changeId',data.id);
                this.$router.push({
                    path:'/course/courseDetail',
                    query: { id: data.id }
                });
                CoursePages.current=this.pages.current;
                CoursePages.currentCategory=this.currentCategory;
                CoursePages.keywords=this.pages.keywords;
            },
            /**清空搜索 */
            clearSearch(){
                this.pages.keywords='';
                this.search();
            },
            changeCurrent(e){
                this.pages.current=e;
                this.virtualCoursePageList();
            },
            initVPages(){
                CoursePages.current=1;
                CoursePages.currentCategory='';
                CoursePages.keywords='';
            },
            /**已发布课程列表查询 */
            virtualCoursePageList(){
                var params={
                "classifyCode": this.currentCategory,
                "courseName": this.pages.keywords,
                "tenantId":'',
                "current": this.pages.current,
                "size": this.pages.size
                }
                VirtualCoursePageList(params).then(res=>{
                    if(res.code==200){
                        this.heartCourseList=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            search(){
                this.pages.current=1;
                this.virtualCoursePageList();
            },
            /**切换分类 */
            changeCategory(item){
                this.currentCategory=item.value;
                this.search();
            }
        },
        mounted(){
            this.pages.current=CoursePages.current;
            this.currentCategory=CoursePages.currentCategory||'';
            this.pages.keywords=CoursePages.keywords;
            var category=this.$route.query.category;
            if(category){
                this.currentCategory=category;
            }
            this.virtualCoursePageList();
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-pager>.active {
    background-color: #387dff !important;
}
.clear-active{
    opacity: 1 !important;
}
.icon-Magnifier{
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-48%);
}
.icon-active{
    right: 20px !important;
}
.banner{
    min-height: 60rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(../../assets/image/course/banner.png);
    background-size: 100% 100%;
    padding: 10rem 0;
    &> :nth-child(n){
        padding: 0 5rem;
    }
    &> :nth-child(1){
        font-size: 10rem;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        color: #ffffff;
        text-shadow: 2px 2px 2px #0b77ff; 
    }
    &> :nth-child(2){
        font-size: 4rem;
        letter-spacing: 0.65rem;
        margin-top: 7rem;
    }
    .front{
        color: #0b78ff;
    }
    .after{
        color: #ffffff;
    }
}
.heart-course-box{
    position: relative;
    padding: 6rem var(--padding);
    background-image: url(../../assets/image/course/heart-bg.png);
    background-size: 100% 100%;
    // min-height: 100rem;
}
.heart-box{
    padding-bottom: 6rem;
}
.new-box{
    padding: 3rem 0 8rem 0;
}
.p-title{
        font-weight: 700;
        font-size: 3.4rem;
        color: #151C34;
        margin-top: 6.5rem;
}
.add-img{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6rem;
    cursor: pointer;
}
.menu-box{
    min-height: 20rem;
    background-color: #ffffff;
    padding: 6.5rem var(--padding);
    .top-box{
        display: flex;
        align-items: flex-end;
        &> :nth-child(1){
            color: #151C34;
            font-weight: 700;
            font-size: 3.4rem;
        }
        &> :nth-child(2){
            color: #565A67;
            font-size: 16px;
            margin-left: 4rem;
        }
    }
}
.category-box{
    color: #3F3F3F;
    display: flex;
    font-size: 1.8rem;
    column-gap: 6rem;
    row-gap: 1rem;
    margin-right: 2rem;
    flex-wrap: wrap;
    &> :nth-child(n){
        cursor: pointer;
    }
}
.blue-line{
    height: 3px;
    width: 2rem;
    background-color: #3972FF;
    margin-top: 5px;
    margin-left: calc(50% - 1rem);
    opacity: 0;
}
.active-block{
    opacity: 1;
}
.active{
    color: #3972FF;
}
.bottom-box{
    /deep/.el-input{
        width: auto;
    }
    /deep/.el-input__inner{
    width: 24rem;
    height: 4rem;
    border: 1px solid #d7d9e1;
    border-radius: 2.1rem;
    padding-left: 2.5rem;
    padding-right: 6rem;
}
}
.input{
    position: relative;
    i{
        position: absolute;
        right: 2rem;
        font-size: 1.8rem;
        top: 50%;
        transform: translateY(-50%);
        color: #000000;
        cursor: pointer;
    }
    .el-icon-circle-close{
        position: absolute;
        right: 4rem;
        top: 50%;
        font-size: 16px;
        transform: translateY(-50%);
        color: #d7dae2;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
    }
    .el-icon-circle-close:hover{
        color: var(--blue);
    }
}
.bottom-box{
    display: flex;
    margin-top: 6rem;
    justify-content: space-between;
    align-items: flex-start;
}
.t-page-box{
    display: flex;
    justify-content: center;
    padding: 2rem 0;
}
input:focus {
  outline: none; /* 首先移除默认的轮廓样式 */
  border: 1px solid #3972FF; /* 设置焦点时的边框颜色 */
  transition: all 0.3s;
}
input::placeholder {
    font-size: 14px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
@media screen and (max-width:750px){
    .banner{
        white-space: normal;
        min-height: auto !important;
        &> :nth-child(1){
            font-size: var(--bigTitle) !important;
            padding: 0 var(--padding) !important;
        }
        &> :nth-child(2){
            font-size: var(--smallTitle) !important;
            padding: 0 var(--padding) !important;
            margin-top: 2rem !important;
        }
    }
    .menu-box{
        padding-top: 4rem;
        padding-bottom: 4rem;
    }
    .top-box{
        flex-direction: column;
        align-items: center !important;
        &> :nth-child(2){
            margin-left: 0 !important;
            margin-top: 1rem;
        }
    }
    .menu-box{
        height: auto;
    }
    .bottom-box{
        margin-top: 3rem;
        flex-direction: column;
        /deep/.el-select{
            width: 100%;
        }
        /deep/.el-input{
            width: 100%;
        }
        /deep/.el-input__inner{
            width: 100%;
        }
    }
}
</style>